<template>
  <div class="health-info">
    <div class="health-info-header">
      <div class="health-info-title">物品信息</div>
      <div class="health-info-checkbox" @click="onSelect" v-if="isRead">
        <div class="health-info-icon">
          <img v-if="allOk" src="@/assets/selected.png" />
          <img v-else src="@/assets/unselected.png" />
        </div>
        <div class="all-title">全部完好</div>
      </div>
    </div>
    <div class="health-info-list" v-for="item in orderTagList" :key="item.id">
      <div class="health-info-list-title">{{ item.name }}
          <div class="hide-title">
              <div v-for="hideItem in orderTagList" :key="hideItem.id">{{hideItem.name}}
              </div>
          </div>
      </div>
      <div class="health-info-list-line"></div>
      <div class="scroll-view" style="overflow-x: auto; display: flex;">
        <div v-for="tagItem in item.children" :key="tagItem.id" class="scroll-view-item" >
        <div
            class="scroll-view-item"
            :class="{ active: tagItem.selected }"
            @click="onSelect(tagItem)"
            v-show="tagItem.selected || isRead"
          >

            {{ tagItem.name }}
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "orderTag",
  props: {
    orderTagList: {
      type: Array,
      default: () => [],
      observer(val) {
        if (val.length) {
          let isGoodList = [];
          val.forEach(e => {
            e.children.forEach(e1 => {
              if (e1.isGood === 1) {
                isGoodList.push(true);
              }
            });
          });

          let okList = [];
          val.forEach(item => {
            item.children.forEach(item1 => {
              if (item1.isGood === 1 && item1.selected) {
                okList.push(true);
              }
            });
          });

          this.allOk = okList.length === isGoodList.length && isGoodList.length >= val.length && isGoodList.length !== 0;
        }
      }
    },
    isRead: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      allOk: false
    };
  },
  methods: {
    onSelect(tagItem) {
      const id = tagItem.id;
      this.$emit('select', { id });
    }
  }
};
</script>

<style scoped>

.health-info {
  /* margin: 24px 0; */
}

.health-info-header {
  border-bottom: 1px #e1e1e1 solid;
  padding: 38px 0;
  display: flex;
  justify-content: space-between;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 46px;
  color: #171819;
}

.health-info-checkbox {
  display: flex;
  align-items: center;
}

.health-info-icon {
  width: 40px;
  height: 40px;
  margin-right: 8px;
}

.health-info-icon image {
  width: 40px;
  height: 40px;
}

.health-info-list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-bottom: 1px solid #E3E3E3;
  padding: 13px 0;
}

.health-info-list-title {
  flex-shrink: 0;
  position: relative;
  /* max-height: 48px; */
  overflow-y: hidden;
  line-height: 48px;
  width: 98px;
  word-wrap: break-word; 
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #8B8B8B;
}

.hide-title {
  visibility: hidden;
}

.hide-title {
  visibility: hidden;
}

.health-info-list-line {
  width: 1px;
  height: 28px;
  background-color: #999;
  margin: 0 12px 0 43px;
}

.scroll-view {
  display: flex;
  flex-wrap: nowrap;
  height: 72px;
  overflow: scroll;
}

.scroll-view-item {
  height: 48px;
  padding: 0 24px;
  border: 1px solid #e1e1e1;
  background-color: rgba(238, 238, 238, .6);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 12px 0;
  margin-right: 10px;
  flex-shrink: 0;

  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #343434;
}

.scroll-view-item.active {
  border: 1px solid rgba(54,111,254,1);
  background-color: rgba(54,111,254,.2);
  color: rgba(54,111,254,1);
}

.all-title{
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 46px;
  color: #171819;
}
</style>